import { useQuery } from "@apollo/react-hooks";
import { GET_AMOUNT_HISTOGRAM } from "../api/analytics";
import getTimezoneOffset from "../utils/timezone";

const timezoneOffset = getTimezoneOffset();

// 金額分布直方圖：分桶聚合在 server 端完成（涵蓋全部符合條件的交易，
// 不像拉原始明細會受查詢上限截斷），前端只負責標籤與呈現。
export default (filter, { months, startDate, endDate } = {}) => {
  const { data, loading, error } = useQuery(GET_AMOUNT_HISTOGRAM, {
    variables: {
      categoryId: filter && filter.categoryId,
      note: filter && filter.note,
      currencyId: filter && filter.currencyId,
      categoryType: filter && filter.categoryType,
      months,
      startDate,
      endDate,
      timezoneOffset,
    },
    fetchPolicy: "cache-and-network",
    skip: !filter,
  });

  return {
    loading,
    error,
    buckets: data && data.amountHistogram,
  };
};
